<template>
  <v-container fluid py-0>
    <v-row justify="end">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mr-3"
            v-on="on"
            small
            fab
            dark
            color="primary"
            @click="addParticipant"
          >
            <v-icon dark>mdi-account-edit</v-icon>
          </v-btn>
        </template>
        <span>Select Participants</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mr-3"
            v-on="on"
            small
            fab
            dark
            color="green"
            @click="addNewParticipant"
          >
            <v-icon dark>mdi-account-plus</v-icon>
          </v-btn>
        </template>
        <span>Add New Participants</span>
      </v-tooltip>
    </v-row>
    <h5 class="subtitle-2">Participants</h5>
    <v-card outlined>
      <v-data-table :items="participantsList" :headers="headers">
        <template v-slot:item.actions="{ item }">
          <v-btn icon small class="mx-0" @click="onRemoveParticipant(item)">
            <v-icon small color="pink">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <scenario-add-participants-dialog
      :itinerary-participants="itineraryParticipants"
      :show="showAddParticipants"
      @close="showAddParticipants = false"
      @add="onAddParticipants"
      :scenarios="scenarios"
    />
    <add-pax-dialog
      :show="showAddPaxDialog"
      @close="showAddPaxDialog = false"
      @add="onAddPax"
    ></add-pax-dialog>
    <div v-if="debug">
      <code>{{ itineraryParticipants }}</code>
      <code>{{ scenarios }}</code>
    </div>
  </v-container>
</template>

<script>
import ScenarioAddParticipantsDialog from "./ScenarioAddParticipantsDialog.vue";
import AddPaxDialog from "../builder/ItineraryBuilderAddPaxDialog";
export default {
  components: { ScenarioAddParticipantsDialog, AddPaxDialog },
  name: "scenario-participants-list",

  props: {
    value: {
      type: Array,
      defualt: () => [],
    },
    itineraryParticipants: {
      type: Array,
      default: () => [],
    },
    scenarios: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      debug: false,
      showAddParticipants: false,
      showAddPaxDialog: false,
      headers: [
        {
          text: "Title",
          align: "left",
          value: "title",
          name: "title",
        },
        {
          text: "Name",
          align: "left",
          value: "name",
          name: "name",
        },
        {
          text: "Surname",
          align: "left",
          value: "surname",
          name: "surname",
        },
        {
          text: "Assigned to",
          align: "left",
          value: "groups",
          name: "groups",
        },
        {
          text: "Actions",
          align: "center",
          value: "actions",
          name: "actions",
        },
      ],
    };
  },

  computed: {
    participantsList() {
      return this.value.map((p) => {
        const groupsForParticipant = this.scenarios.filter((s) =>
          s.participants.some(
            (pp) =>
              pp.name === p.name &&
              pp.surname === p.surname &&
              pp.title === p.title
          )
        );
        return {
          ...p,
          groups: groupsForParticipant.map((g) => g.name).join(", "),
        };
      });
    },
  },

  methods: {
    addNewParticipant() {
      console.log("adding new participant");
      this.showAddPaxDialog = true;
    },
    addParticipant() {
      this.showAddParticipants = true;
    },
    onAddPax(c) {
      this.$emit("add-participant", {
        id: c.id,
        title: c.title,
        name: c.name,
        surname: c.surname,
        clientId: c.id,
      });
      this.showAddParticipants = false;
    },
    onAddParticipants(payload) {
      this.showAddParticipants = false;
      this.$emit(
        "add-participants",
        payload.map((p) => ({
          id: p.id,
          title: p.title,
          name: p.name,
          surname: p.surname,
          clientId: p.client ? p.client.id : null,
        }))
      );
    },
    onRemoveParticipant(p) {
      this.$emit("remove-participant", p);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/scenarios/ScenarioParticipantsList.vue